module.exports = {
	"textures": [
		{
			"image": "VirtualWheel.png",
			"format": "RGBA8888",
			"size": {
				"w": 1024,
				"h": 1024
			},
			"scale": 1,
			"frames": [
				{
					"filename": "wheel_bottom.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 500,
						"h": 500
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 500,
						"h": 500
					}
				},
				{
					"filename": "wheel_top.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 500,
						"h": 500
					},
					"frame": {
						"x": 1,
						"y": 503,
						"w": 500,
						"h": 500
					}
				},
				{
					"filename": "wheel_top_double_zero.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 500,
						"h": 500
					},
					"frame": {
						"x": 503,
						"y": 1,
						"w": 500,
						"h": 500
					}
				},
				{
					"filename": "FastForwardButton_Clicked.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 121,
						"h": 120
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 121,
						"h": 120
					},
					"frame": {
						"x": 503,
						"y": 503,
						"w": 121,
						"h": 120
					}
				},
				{
					"filename": "FastForwardButton_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 121,
						"h": 120
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 121,
						"h": 120
					},
					"frame": {
						"x": 626,
						"y": 503,
						"w": 121,
						"h": 120
					}
				},
				{
					"filename": "FastForwardButton_MouseOver.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 121,
						"h": 120
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 121,
						"h": 120
					},
					"frame": {
						"x": 749,
						"y": 503,
						"w": 121,
						"h": 120
					}
				},
				{
					"filename": "FastForwardButton_Normal.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 121,
						"h": 120
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 121,
						"h": 120
					},
					"frame": {
						"x": 872,
						"y": 503,
						"w": 121,
						"h": 120
					}
				},
				{
					"filename": "SpinButton_Clicked.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 121,
						"h": 120
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 121,
						"h": 120
					},
					"frame": {
						"x": 503,
						"y": 625,
						"w": 121,
						"h": 120
					}
				},
				{
					"filename": "SpinButton_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 121,
						"h": 120
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 121,
						"h": 120
					},
					"frame": {
						"x": 503,
						"y": 747,
						"w": 121,
						"h": 120
					}
				},
				{
					"filename": "SpinButton_MouseOver.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 121,
						"h": 120
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 121,
						"h": 120
					},
					"frame": {
						"x": 503,
						"y": 869,
						"w": 121,
						"h": 120
					}
				},
				{
					"filename": "SpinButton_Normal.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 121,
						"h": 120
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 121,
						"h": 120
					},
					"frame": {
						"x": 626,
						"y": 625,
						"w": 121,
						"h": 120
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:4f7409579b4591273e0b8235c444c3fc:3201194384e6491c6277c55c1d245b7c:737fc2ac3e3f261184b1203dc21cfa40$"
	}
}
;